module.exports = "/fonts/vendor/line-awesome/dist/line-awesome/la-brands-400.eot?908ce19d18187969b32f22234c7fc8af";